import script from "./generic-result-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./generic-result-item.vue?vue&type=script&setup=true&lang=ts"

import "./generic-result-item.vue?vue&type=style&index=0&id=38dc9c62&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38dc9c62"]])

export default __exports__